import React, { useState } from "react";
import { request } from "../api/client";
import { stashReturnForOAuth } from "../api/playTicket";
import { yandexStartPath } from "../api/authGateway";

/**
 * Кнопка «Войти через Яндекс» для Рублокса.
 *
 * Запрашивает у бэка authorize_url с CSRF-state, делает window.location.href
 * на oauth.yandex.ru. После авторизации Яндекс редиректит на
 * https://rublox.pro/auth/yandex/callback?code=...&state=...
 *
 * Используем request() из api/client — там зашит API_BASE
 * (https://minecraftia-school.ru), потому что у Рублокса нет своего
 * api-прокси на /api-user/, все запросы летят через CORS на майнкрафтию.
 */
export default function YandexLoginButton({ disabled }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const onClick = async () => {
    setBusy(true);
    setErr("");
    try {
      // Запоминаем ?return (инвайт-ссылка) — Яндекс вернёт только code+state,
      // query потеряется; восстановим в callback после входа.
      stashReturnForOAuth();
      /* Путь берём у шлюза: он знает, какая версия сервиса активна.
         Раньше здесь был жёстко прописан v1 — после его отключения
         кнопка перестала бы работать.

         `frontend` обязателен: Яндекс вернёт человека по redirect_uri,
         а фронтов несколько (школа и Рублокс). Без параметра identity
         подставит домен школы, и вход с rublox.pro уводил бы туда.
         Список разрешённых доменов проверяется на стороне identity —
         подставить чужой адрес нельзя. */
      const frontend = window.location.origin;
      const url = yandexStartPath(frontend);
      const data = url.startsWith("http")
        ? await fetch(url).then((r) => r.json())
        : await request(url, { method: "GET" });
      if (!data || !data.authorize_url) {
        setErr(data?.message || "Не удалось начать вход");
        setBusy(false);
        return;
      }
      window.location.href = data.authorize_url;
    } catch (e) {
      setErr(e?.message || "Сеть недоступна");
      setBusy(false);
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <button
        type="button"
        onClick={onClick}
        disabled={disabled || busy}
        style={{
          width: "100%",
          height: 46,
          marginTop: 12,
          background: "#000",
          color: "#fff",
          border: "none",
          borderRadius: 10,
          fontSize: 15,
          fontWeight: 600,
          cursor: disabled || busy ? "not-allowed" : "pointer",
          opacity: disabled || busy ? 0.6 : 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 10,
        }}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="11" fill="#FC3F1D" />
          <path d="M13.3 18.5h2.05V5h-3.05c-2.85 0-4.6 1.5-4.6 4 0 1.8.9 2.95 2.45 3.7L7.5 18.5h2.2l2.85-6h.75v6zm-1.05-7.85h-.8c-1.5 0-2.3-.85-2.3-2.3 0-1.5.8-2.2 2.3-2.2h.8v4.5z" fill="#fff" />
        </svg>
        {busy ? "Открываем Яндекс..." : "Войти через Яндекс"}
      </button>
      {err && (
        <div style={{ color: "#dc2626", fontSize: 13, marginTop: 6, textAlign: "center" }}>
          {err}
        </div>
      )}
    </div>
  );
}
